import React from 'react';
const items = [<>
    <strong className="font-bold" data-id="element-191">Cómo Crear videos UGC auténticos</strong> y
    que generan CIENTOS de ventas 💸💸
  </>, <>
    <strong className="font-bold" data-id="element-192">Cómo grabar, editar y estructurar</strong>{' '}
    <em data-id="element-193">tus videos como una Creadora PRO</em>
  </>, <>
    <strong className="font-bold" data-id="element-194">Cómo armar tu portfolio profesional</strong>{' '}
    <em data-id="element-195">con mis plantillas</em>
  </>, <>
    <strong className="font-bold" data-id="element-196">Cómo trabajar con marcas</strong>{' '}
    <em data-id="element-197">sin experiencia ni miles de seguidores</em>
  </>];
export function LearnSection() {
  return <section className="px-6 py-10 flex flex-col items-center text-center" data-id="element-198">
      <div className="w-full max-w-5xl bg-white rounded-[2.5rem] p-8 md:p-16 shadow-sm border border-white/50" data-id="element-199">
        <h2 className="font-serif text-3xl md:text-5xl text-brand-navy mb-10" data-id="element-200">
          ¿Qué vas a aprender?
        </h2>

        <ol className="w-full grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-7 text-left" data-id="element-201">
          {items.map((item, i) => <li key={i} className="font-serif text-[19px] md:text-[22px] text-brand-navy leading-snug" data-id="element-202">
              <span className="font-bold" data-id="element-203">{i + 1}.</span> {item}
            </li>)}
        </ol>
      </div>
    </section>;
}